<template>
  <div>
    <iframe
      id="ifrList"
      name="ifrList"
      class="container external-page"
      :src="src"
    >
    </iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: '',
    };
  },

  created() {
    const url = atob(this.$route.query.code);
    this.src = `${url}?hash=${this.$cookies.get('hash')}`;
    //this.src = `http://localhost?hash=${this.$cookies.get('hash')}`;
    // alert(`this.$route.query: ${JSON.stringify(this.$route.query)}`);
  }
}
</script>

<style scoped>
  .external-page {
    width:100vw;
    height: 93vh;
  }
</style>